<template>
	<md-dialog :md-active="$route.name == 'editHWConfiguration'" v-if="hWConfiguration" :md-click-outside-to-close=false :md-close-on-esc=false @md-clicked-outside="close" @keydown.esc="close">
		<md-dialog-title>Edit</md-dialog-title>
		<md-dialog-content>
			<div class="md-layout">
				<div class="md-layout-item">
					<md-field>
						<label for="name">Name</label>
						<md-input name="name" id="name" v-model="hWConfiguration.name" readonly required/>
					</md-field>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
					<md-field>
						<label for="description">Description</label>
						<md-input name="description" id="description" v-model="hWConfiguration.description" :disabled="sending" />
					</md-field>
				</div>
			</div>
			<div class="md-layout md-gutter">
				<div class="md-layout-item">
					<md-field>
						<label>Manifest fields</label>
						<md-select v-model="hWConfiguration.manifestFields" name="manifestFields" id="manifestFields" multiple>
							<md-option v-for="field in $store.getters.manifestFields" :key="field.id" :value="field.id">{{field.name}}</md-option>
						</md-select>
					</md-field>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
				<md-chips v-model="hWConfiguration.tags" md-placeholder="Tags"></md-chips>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
				<dialog-link-table :links="hWConfiguration.links"/>
				</div>
			</div>

			<md-progress-bar md-mode="indeterminate" v-if="sending" />
			<md-dialog-actions>
				<md-button class="md-primary" @click="close" :disabled="sending">Close</md-button>
			</md-dialog-actions>
		</md-dialog-content>
	</md-dialog>
</template>

<script>
import debounce from '../../mixins/debounce'
import DialogLinkTable from '../Common/DialogLinkTable.vue'

export default {
	name: 'Edit',
	components: { 'dialog-link-table': DialogLinkTable },
	data: () => ({
		sending: false,
		hWConfiguration: null
	}),
	mixins: [debounce],
	watch: {
		hWConfiguration: {
			deep: true,
			async handler() {
				await this.update()
			}
		}
	},
	created() {
		this.hWConfiguration = this.$store.getters.getHWConfigurationById(this.$route.params.eid)
		this.hWConfiguration.manifestFields = this.hWConfiguration.manifestFields.map((mF) => mF.id)
		this.hWConfiguration.tags = this.hWConfiguration.tags.map((tag) => tag.tag)
		this.update = this.debounce(this.update)
	},
	methods: {
		async updateHWConfiguration() {
			this.sending = true
			try {
				const tagIds = await this.$apiService.createTagsIfNotExist(this.hWConfiguration.tags)
				await this.$apiService.hWConfiguration.update(this.hWConfiguration.id, {
					description: this.hWConfiguration.description,
					tagIds,
					links: this.hWConfiguration.links,
					manifestFieldIds: this.hWConfiguration.manifestFields
				})
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.sending = false
		},
		async update() {
			await this.updateHWConfiguration()
		},
		async close() {
			try {
				await this.$store.dispatch('loadHWConfigurations', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.$router.back()
		}
	}
}
</script>

<style scoped>
.info {
	margin-left: 20px
}
</style>
